import { graphql } from 'gatsby'
import React, { useContext , useEffect} from "react"

import { renderSections } from '../helpers/renderer'
import Layout from '../components/layout'
import Section from '../components/section'
import styled from "styled-components"

import queryString from 'query-string'

import {
  GlobalDispatchContext,
  GlobalStateContext,
} from "../context/GlobalContextProvider"

const StandardPage = props => {

  let params = queryString.parse(props.location.search)

  const dispatch = useContext(GlobalDispatchContext)
  const state = useContext(GlobalStateContext)

  useEffect(() => {
    if ( params.utm_source ){
      dispatch({ type: "SET_UTM_SOURCE", payload:params.utm_source })
    }
    if ( params.utm_campaign ){
      dispatch({ type: "SET_UTM_CAMPAIGN", payload:params.utm_campaign })
    }
    if ( params.utm_medium ){
      dispatch({ type: "SET_UTM_MEDIUM", payload:params.utm_medium })
    }
  }, [dispatch, params])


  const {
    body: sections,
    alt_hero_logo: altHeroLogo,
    hero_image: heroImage,
    overlay: { html: overlay },
    caption: { text: caption },
    focal_point: focalPoint,
    url_base: { text: lang }
  } = props.data.prismicStandardPage.data

  const lan = lang ? lang.slice(0, 2) : 'en';

  return (
    <Layout lang={lan} alt_hero_logo={altHeroLogo.url} utm_campaign={state.utm_campaign} utm_source={state.utm_source} utm_medium={state.utm_medium}>
      <Section background="#333" color="#FFF" image={heroImage.url} height="calc(100vh - 4rem)" center focalPoint={focalPoint}>
        <div dangerouslySetInnerHTML={{ __html: overlay }} />
        {!!caption && <Caption>{caption}</Caption>}
      </Section>
      {renderSections(sections)}
    </Layout>
  )
}

export default StandardPage



export const pageQuery = graphql`
  query ($id:String) {
    prismicStandardPage(id: { eq: $id }) {
      id
      uid
      data {
        page_title { text }
        caption { text }
        focal_point
        url_base { text }
        body {
          ... on PrismicStandardPageBody5050ImageSplit { ...StandardPage5050ImageSplit }
          ... on PrismicStandardPageBodyCarousel { ...StandardPageCarousel }
          ... on PrismicStandardPageBodyFeatureSection { ...StandardPageFeatureSection }
          ... on PrismicStandardPageBodyFullWidthImage { ...StandardPageFullWidthImage }
          ... on PrismicStandardPageBodyImageTextSplit { ...StandardPageImageTextSplit }
          ... on PrismicStandardPageBodyMap { ...StandardPageMap }
          ... on PrismicStandardPageBodyFadeCounterRow { ...StandardPageFadeCounterRow }
          ... on PrismicStandardPageBodyQuoteSection { ...StandardPageQuoteSection }
        }
        alt_hero_logo { url }
        hero_image { url }
        overlay { html }
      }
    }
  }
`

const Caption = styled.p`
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  color: #FFF;
  font-size: 10px;
`
